export default {
  contact_us: "Contactez-nous",
  credits: "© :YEAR :NAME. Tous droits réservés.",
  date_intervals: {
    different_day: ":start au :end",
    same_day: ":date de :start à :end",
  },
  designed_developed_by: "Conception et développement web par <strong>Beet</strong>.",
  event: {
    future: "Événements à venir",
    no_upcoming: "Aucun événement à venir pour le moment.",
    past: "Événements passés",
    return: "Retour aux événements",
    see_all: "Voir tous les événements",
  },
  links_to_consult: "Liens à consulter",
  navigation: {
    about: "À propos de nous",
    activities: "Nos activités",
    careers: "Joindre l'équipe",
    research: "Notre recherche",
  },
  news: {
    return: "Retour aux nouvelles",
    see_all: "Voir toutes les nouvelles",
  },
  not_found: {
    button: "Retourner à l'accueil",
    description:
      "<p>Nous n'arrivons pas à trouver la page que vous cherchez. Essayez d'explorer notre site!</p>",
    title: "Oops, quelque chose a été égaré!",
  },
  page_titles: {
    home: "Accueil",
    about: "À propos",
    careers: "Carrières",
    resources: "Ressources",
    events: "Événements",
    funding: "Financement",
    innovation: "Innovation sociale",
    news: "Nouvelles",
    posts: "Publications",
    policies: "Politique de confidentialité",
    projects: "Projets",
    team: "Équipe",
    not_found: "Page non trouvée",
  },
  policies: {
    content: "<p>Contenu à venir...</p>",
    title: "Politique de confidentialité",
  },
  read_more: "Lire la suite",
  search: "Recherche",
  see_more: "Voir plus",
  site_title: "Réseau de proximité",
  view: "Consulter",
};
